var map = {
	"./bg_BG.json": "2224",
	"./da.json": "21aa",
	"./en.json": "edd4",
	"./es_ES.json": "9152",
	"./fi.json": "5754",
	"./nb.json": "85fc",
	"./nl.json": "a625",
	"./pt_PT.json": "e76c",
	"./sv.json": "4c5b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";